import React, { useEffect, useMemo } from 'react';
import { Container, Box } from '@mui/material';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import { PAGES_GA_IDENTIFIERS } from 'views/common/utils/constants';
import StyledBox from 'views/rebranded-module/blogs-module/BlogDetailsViewV2/BlogDetailsViewV2.styles';
import {
  HeaderSection,
  ContentSection,
  ContentSectionSkeleton,
  ShareSection,
  ShareSectionSkeleton,
} from 'views/rebranded-module/blogs-module/BlogDetailsViewV2/components';
import { LazyLoad } from 'views/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import dayjs from 'dayjs';
import { DATE_FORMAT_FULL } from 'views/rebranded-module/common/utils/dateFormate';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { ImgBox } from 'views/rebranded-module/common/components';

interface BlogDetailsViewV2Props {
  serverData: any;
}

const BlogDetailsViewV2: React.FC<BlogDetailsViewV2Props> = (props) => {
  const { serverData: blogData } = props;
  const getSizedImage = useAdabtiveMultiSizeImage();
  const content = useContent('BlogDetailsPage');
  const postedDate = useMemo(() => {
    if (!blogData?.blog_post?.posted_on) return '';
    const date = dayjs(blogData.blog_post.posted_on);
    return date.format(DATE_FORMAT_FULL);
  }, [blogData]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'landing_page_view', {
        page_identifier: PAGES_GA_IDENTIFIERS.BLOG,
      });
    }
  }, []);

  if (!blogData) {
    return null;
  }

  return (
    <>
      <Head>
        {blogData?.seo_values && generateMetaData(blogData.seo_values)}
      </Head>
      <StyledBox>
        <Box className="BDVBGContainer">
          <ImgBox
            image={{
              src: getSizedImage(content.patternBackground),
              alt: content.patternBackground.alt,
            }}
            width="100%"
            height="100%"
          />
        </Box>
        <Container maxWidth="xl" className="BDVCustomeContainer">
          <HeaderSection
            title={blogData?.blog_post?.title}
            postedDate={postedDate}
          />
          <LazyLoad skeleton={<ContentSectionSkeleton />} dataLoaded={blogData}>
            <ContentSection description={blogData?.blog_post?.description} />
          </LazyLoad>
          <LazyLoad skeleton={<ShareSectionSkeleton />} dataLoaded={blogData}>
            <ShareSection blogTitle={blogData?.blog_post?.title} />
          </LazyLoad>
        </Container>
      </StyledBox>
    </>
  );
};

export { BlogDetailsViewV2 };
